import { render } from "./LoanBook.vue?vue&type=template&id=3a7db260&scoped=true"
import script from "./LoanBook.vue?vue&type=script&lang=js"
export * from "./LoanBook.vue?vue&type=script&lang=js"

import "./LoanBook.vue?vue&type=style&index=0&id=3a7db260&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aiden\\OneDrive - Qismat\\Development\\brydg-bdp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7db260"]])

export default __exports__